module.exports = {};


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_iterators.js
 **/